<template>
  <UiToastHost />
  <LoginPage v-if="showLogin" />

  <div
    v-else
    :class="[
      'dashboard-shell',
      sidebarCollapsed
        ? 'lg:grid-cols-[88px_minmax(0,1fr)]'
        : 'lg:grid-cols-[280px_minmax(0,1fr)]',
    ]"
  >
    <Transition name="fade">
      <button
        v-if="mobileOpen"
        class="fixed inset-0 z-30 bg-slate-950/50 lg:hidden"
        aria-label="Đóng menu"
        @click="mobileOpen = false"
      />
    </Transition>
    <aside
      :class="[
        'fixed inset-y-0 left-0 z-40 w-[280px] transform transition-all duration-200 lg:static lg:translate-x-0',
        sidebarCollapsed ? 'lg:w-[88px]' : 'lg:w-[280px]',
        mobileOpen ? 'translate-x-0' : '-translate-x-full',
      ]"
    >
      <TopNavBar
        :full-name="fullName"
        :team="team"
        :collapsed="sidebarCollapsed"
        @toggle-collapse="sidebarCollapsed = !sidebarCollapsed"
        @navigate="mobileOpen = false"
      />
    </aside>

    <main class="dashboard-main">
      <header
        class="sticky top-0 z-20 border-b border-white/10 bg-brand-900/80 backdrop-blur"
      >
        <div
          class="mx-auto flex min-h-[74px] max-w-[1600px] items-center justify-between gap-3 px-3 py-2 sm:px-4 lg:px-6"
        >
          <div class="flex min-w-0 items-center gap-2.5 text-white">
            <UiButton
              variant="ghost"
              size="icon"
              icon="menu"
              class="bg-white/10 text-white hover:bg-white/20 lg:hidden"
              @click="mobileOpen = true"
            />
            <div class="min-w-0 text-left leading-none">
              <p class="truncate text-xs font-medium leading-4 text-blue-100">
                Hệ thống quản lý tài sản
              </p>
              <p class="mt-0.5 truncate text-lg font-black leading-7">
                Dashboard vận hành
              </p>
            </div>
          </div>

          <div
            class="hidden min-h-10 shrink-0 items-center gap-2 rounded-full border border-white/15 bg-white/10 px-2.5 py-1.5 text-white md:flex"
          >
            <div
              class="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-white text-xs font-bold text-brand-700"
            >
              {{ initials }}
            </div>
            <div class="max-w-[220px] text-left leading-none">
              <p class="truncate text-xs font-semibold leading-4">
                {{ fullName || "Người dùng" }}
              </p>
              <p class="truncate text-[11px] leading-3 text-blue-100">
                {{ team || "Chưa có khoa/phòng" }}
              </p>
            </div>
          </div>
        </div>
      </header>

      <router-view />
    </main>
  </div>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import TopNavBar from "@/components/TopNavBar.vue";
import LoginPage from "@/pages/LoginPage.vue";
import UiToastHost from "@/components/ui/UiToastHost.vue";

export default {
  components: { TopNavBar, LoginPage, UiToastHost },
  setup() {
    const store = useStore();
    const route = useRoute();
    const mobileOpen = ref(false);
    const sidebarCollapsed = ref(false);
    const fullName = computed(() => store.state.fullName || "");
    const team = computed(() => store.state.team || "");
    const isLoggedIn = computed(() => !!store.state.token);
    const showLogin = computed(
      () => !isLoggedIn.value || route.name === "login",
    );
    const initials = computed(() => {
      const source = fullName.value || "QL";
      return source
        .split(" ")
        .filter(Boolean)
        .slice(-2)
        .map((part) => part.charAt(0).toUpperCase())
        .join("");
    });

    return {
      showLogin,
      mobileOpen,
      sidebarCollapsed,
      fullName,
      team,
      initials,
    };
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

